import { Card, CardBody, Col, Row } from 'reactstrap'
import { H4, H5, H6 } from '../../../../AbstractElements'
import { TotalSaleData } from '../../../../Data/General/Widgets/Chart'
import ReactApexChart from 'react-apexcharts'
import { Fragment } from 'react/jsx-runtime'

const TotalSale = () => {
  return (
    <Fragment>
      {TotalSaleData.map((item, index) => (
        <Col xl="4" md="6" className="box-col-4" key={index}>
          <Card className="o-hidden">
            <div className="chart-widget-top">
              <CardBody className="pb-0 m-0">
                <Row>
                  <Col xl="9" lg="8" xs="9">
                    <H4 className="mb-2 f-w-600">{item.title}</H4>
                    <H5>{item.price}</H5>
                    <span>{`Compare to last month`}</span>
                  </Col>
                  <Col xl="3" lg="4" xs="3" className="text-end p-0">
                    <H6 className="txt-success">{`+65%`}</H6>
                  </Col>
                </Row>
              </CardBody>
              <div>
                <div className={item.chartClass}>
                  <ReactApexChart options={item.chart} series={item.chart.series} type={item.chart.chart?.type} height={item.chart.chart?.height} />
                </div>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Fragment>
  )
}

export default TotalSale